import { render, staticRenderFns } from "./HomeConfig.vue?vue&type=template&id=27763366&scoped=true&lang=html"
import script from "./HomeConfig.vue?vue&type=script&lang=js"
export * from "./HomeConfig.vue?vue&type=script&lang=js"
import style0 from "./HomeConfig.vue?vue&type=style&index=0&id=27763366&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27763366",
  null
  
)

export default component.exports